// src/components/LoadingSpinner.jsx
const LoadingSpinner = () => (
  <div className="p-4">
    <div className="text-center py-4">
      <div className="animate-pulse text-gray-600">Loading data...</div>
    </div>
  </div>
);

export default LoadingSpinner;  // Use default export
